import { useArticleStore } from '~/store/article';
// import type { PublicationContext } from '~/types';

/*
 * function getDnSegment () {
 *   let dnSegment: string[] = [];
 *   const priorityMap: any = (useRuntimeConfig().public as unknown as
 *     PublicationContext).dnSegmentPriorityMap || {};
 *   const dnSegmentStr = localStorage.getItem('gpt_aamsegments_value');
 *   if (dnSegmentStr?.trim()) {
 *     dnSegment = dnSegmentStr.split(',');
 *     dnSegment.sort((a, b) => {
 *       const p1: number = priorityMap[a]?.priority || Infinity;
 *       const p2: number = priorityMap[b]?.priority || Infinity;
 *       if (p1 === p2) {
 *         const o1: number = priorityMap[a]?.order || Infinity;
 *         const o2: number = priorityMap[b]?.order || Infinity;
 *         return o1 - o2;
 *       }
 *       return p1 - p2;
 *     });
 *     dnSegment.splice(10);
 *   }
 *   return dnSegment;
 * }
 */

export default function useAdOpenRTBSignal (pageType: string) {
  if (import.meta.client && typeof window?.lwhb?.ortb2 === 'function') {
    const topic = pageType === 'article' ? useArticleStore().currentArticle?.topic?.label || '' : '';
    window.lwhb.ortb2({
      site: {
        ext: {
          data: {
            dn_topic: topic
          }
        }
      }
    });
  }
}
